export default __webpack_public_path__ + "static/media/refar-friend.80498556.png";